import styled from 'styled-components'

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  background: ${({ theme }) => theme.palette.gray[50]};
  min-height: 100vh;
`;

export const Header = styled.div`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 40px 30px;
  border-radius: 16px;
  margin-bottom: 30px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 2.5rem;
  font-weight: 700;
  line-height: 1.2;
  
  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
`;

export const PriceHighlight = styled.span`
  background: rgba(255, 255, 255, 0.2);
  padding: 4px 12px;
  border-radius: 20px;
  font-weight: 600;
`;

export const Section = styled.div`
  background: ${({ theme }) => theme.palette.white};
  border-radius: 12px;
  padding: 30px;
  margin-bottom: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid ${({ theme }) => theme.palette.border.light};
`;

export const SectionTitle = styled.h2`
  margin: 0 0 20px 0;
  font-size: 1.5rem;
  color: ${({ theme }) => theme.palette.text.primary};
  font-weight: 600;
`;

export const TableHeader = styled.thead`
  background: linear-gradient(90deg, #4299e1, #3182ce);
  color: white;
  
  th {
    padding: 16px 12px;
    text-align: left;
    font-weight: 600;
    font-size: 0.9rem;
    
    @media (max-width: 768px) {
      padding: 12px 8px;
      font-size: 0.8rem;
    }
  }
`;

export const TableRow = styled.tr`
  border-bottom: 1px solid ${({ theme }) => theme.palette.border.light};
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.palette.gray[50]};
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const TableCell = styled.td`
  padding: 16px 12px;
  color: ${({ theme }) => theme.palette.text.secondary};

  @media (max-width: 768px) {
    padding: 12px 8px;
    font-size: 0.9rem;
  }
`;

export const BuyButton = styled.button`
  background: linear-gradient(135deg, #48bb78, #38a169);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(72, 187, 120, 0.3);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

export const AirlinesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const InfoCard = styled.div`
  background: linear-gradient(135deg, #edf2f7, #e2e8f0);
  padding: 24px;
  border-radius: 12px;
  border-left: 4px solid #4299e1;
`;

export const SimilarDirections = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const DirectionGroup = styled.div`
  h3 {
    color: ${({ theme }) => theme.palette.text.primary};
    font-weight: 600;
    margin-bottom: 12px;
  }
`;

export const DirectionList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const SEOContent = styled.div`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 1rem;
  line-height: 1.7;

  p {
    margin-bottom: 16px;
  }
`;